import Global from '../../global';

const brandIdES = 58;
const brandIdDK = 75;
const brandIdRO = 76;
const brandIdDE = 84;

const defaultEmptyClientRoutes = ['upfor8'];
const defaultReservedRoutes = ['upfor8'];

const emptyClientRoutesForSportClient = [
  'test-page-cta',
  'general-test-page',
  '888event',
  'filter\\/politics\\/?(?!(.*\\/)?[\\d]+\\/*$).*$', // any politics route that doesn't end in numbers (ie event page)
  'standalone-strip/highlights'
];
const reservedRoutesForSportClient = [
  'test-page-cta',
  'general-test-page',
  '888event',
  'standalone-strip/highlights'
];

export default {
  getEmptyClientRoutes: function (brand) {
    let routes = defaultEmptyClientRoutes;

    if (!Global.isProduction) {
      routes = routes.concat(emptyClientRoutesForSportClient);
    }

    if (Global.config.enableSCHomePage) {
      routes = routes.concat(['home']);
    }

    if (brand === brandIdES) {
      routes = routes.concat(['porra8']);
    }

    if (brand === brandIdDK) {
      routes = routes.concat(['8rigtige']);
    }

    if (brand === brandIdRO) {
      routes = routes.concat(['super8']);
    }

    if (brand === brandIdDE) {
      routes = routes.concat(['super8']);
    }

    return routes;
  },

  getReservedRoutes: function (brand) {
    let routes = defaultReservedRoutes;

    if (!Global.isProduction) {
      routes = routes.concat(reservedRoutesForSportClient);
    }

    if (Global.config.enableSCHomePage) {
      routes = routes.concat(['^home']);
    }

    if (brand === brandIdES) {
      routes = routes.concat(['porra8']);
    }
    
    if (brand === brandIdDK) {
      routes = routes.concat(['8rigtige']);
    }

    if (brand === brandIdRO) {
      routes = routes.concat(['super8']);
    }

    if (brand === brandIdDE) {
      routes = routes.concat(['super8']);
    }

    return routes;
  }
};
